<template>
  <div class="form-group row">
    <label class="col-sm-5 col-form-label">{{ label }}</label>
    <div class="col-sm-7">
      <input
        :type="type"
        :class="'form-control ' + Class()"
        :placeholder="placeholder"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        @keyup="$emit('keyup', $event)"
      />
      <small v-if="error" class="form-text text-danger">{{
        error.join(" ")
      }}</small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "",
    },

    type: {
      type: String,
      default: "text",
    },
    label: String,
    error: {
      type: [String, Number, Array],
      default: null,
    },
    value: {
      type: [String, Number],
    },
    className: {
      type: String,
    },
  },
  methods: {
    Class() {
      return this.className;
    },
  },
};
</script>

<style scoped>
.col-form-label {
  margin-top: 10px;
}
</style>
